import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import * as dat from 'lil-gui'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'

/**
 * Base
 */
// Debug
const gui = new dat.GUI()

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Galaxy
 */
//parametrs
const parameters = {}
parameters.count = 46000
parameters.size = .030
parameters.radius = 5
parameters.branches = 5
parameters.spin = 1.189
parameters.randomness = 1.336
parameters.randomnessPower = 5
parameters.insideColor = '#ff6030'
parameters.outsideColor = '#1b3984'

let geometry = null
let material = null
let points = null

const generateGalaxy = () => {

    //usuniecie poprzedniego, jeśli jest.
    if(points!==null){
        geometry.dispose()
        material.dispose()
        scene.remove(points)
    }

    //geometry
    geometry = new THREE.BufferGeometry()

    const positions = new Float32Array(parameters.count * 3)
    const colors = new Float32Array(parameters.count * 3)

    const colorInside = new THREE.Color(parameters.insideColor)
    const colorOutside = new THREE.Color(parameters.outsideColor)

    for (let i=1; i<parameters.count; i++){
        const i3 = i * 3

        const radius = Math.random() * parameters.radius
        const spinAngle = radius * parameters.spin
        const branchAngle = ((i % parameters.branches) /  parameters.branches) * Math.PI * 2

        const randomX = Math.pow(Math.random(), parameters.randomnessPower) * (Math.random() < .5 ? 1 : -1)
        const randomY = Math.pow(Math.random(), parameters.randomnessPower) * (Math.random() < .5 ? 1 : -1)
        const randomZ = Math.pow(Math.random(), parameters.randomnessPower) * (Math.random() < .5 ? 1 : -1)

        // if (i<20){
        //     console.log(i, branchAngle)
        // }

        positions[i3] = Math.cos(branchAngle+spinAngle) * radius + randomX
        positions[i3+1] = 0 + randomY
        positions[i3+2] = Math.sin(branchAngle+spinAngle) * radius + randomZ
    
        //color
        const mixedColor = colorInside.clone()
        mixedColor.lerp(colorOutside, radius/parameters.radius)
        
        colors[i3] = mixedColor.r
        colors[i3+1] = mixedColor.g
        colors[i3+2] = mixedColor.b
    }
    geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3))
    geometry.setAttribute('color', new THREE.BufferAttribute(colors, 3))

    //material
    material = new THREE.PointsMaterial({
        size: parameters.size,
        sizeAttenuation: true,
        vertexColors: true,
        depthWrite: false,
        blending: THREE.AdditiveBlending,
    })

    //points
    points = new THREE.Points(geometry, material)
    scene.add(points)

    //loggging  
    console.log("działa")
    console.log(parameters)
}
/** kostka
 */

let kostka;
  const gltfLoader = new GLTFLoader()
  gltfLoader.load(
     '/models/kostkav4.glb',
     (gltf) => {
         console.log("success")
         //met1  
         kostka = gltf.scene.children[0]
         kostka.rotation.y = -1
        //  kostka.rotation.z = .4
            kostka.scale.set(0.4, 0.4, 0.4)
         scene.add(kostka)
         // scene.add(gltf.scene.children[0])
         // while(gltf.scene.children.length){
         //     scene.add(gltf.scene.children[0])
         // }
         
     },
     (prog) => {
         console.log("progress")
         // console.log(prog)
     },
     () => {
         console.log("GLTF loading error")
     }
 )

generateGalaxy()

//add to gui
gui.add(parameters, 'count').min(100).max(100000).step(100).onFinishChange(generateGalaxy)
gui.add(parameters, 'size').min(0.001).max(0.1).step(0.001).onFinishChange(generateGalaxy)
gui.add(parameters, 'radius').min(0.01).max(20).step(0.01).onFinishChange(generateGalaxy)
gui.add(parameters, 'branches').min(2).max(10).step(1).onFinishChange(generateGalaxy)
gui.add(parameters, 'spin').min(-5).max(5).step(0.001).onFinishChange(generateGalaxy)
gui.add(parameters, 'randomness').min(0).max(2).step(0.001).onFinishChange(generateGalaxy)
gui.add(parameters, 'randomnessPower').min(1).max(10).step(.001).onFinishChange(generateGalaxy)
gui.addColor(parameters, 'insideColor').onFinishChange(generateGalaxy)
gui.addColor(parameters, 'outsideColor').onFinishChange(generateGalaxy)




/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

 /**
  * cursor
  */
 const cursor = {}
 cursor.x = 0
 cursor.y = 0
 window.addEventListener('mousemove', (event) => {
     cursor.x = event.clientX / sizes.width -.5
     cursor.y = event.clientY / sizes.height -.5
     // console.log(cursor)
 })

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 3
camera.position.y = 2
camera.position.z = 5
scene.add(camera)

/*lights*/
const ambientLight = new THREE.AmbientLight(0xffffff, 0.7)
const pointLight = new THREE.PointLight(0xffffff, 0.7)
pointLight.position.x = 2
pointLight.position.y = 3
pointLight.position.z = 4
scene.add(pointLight)
scene.add(ambientLight)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Animate
 */
const clock = new THREE.Clock()
let previousTime = 0

const tick = () =>
{

    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - previousTime
    previousTime = elapsedTime

    // Update controls
    // controls.update()

    //parralax
    const parallaxX = cursor.x * .5
    const parallaxY = - cursor.y * .5


    if(kostka){
        kostka.rotation.y = elapsedTime * 0.4
        
        //parallax kostki
        kostka.position.x += (parallaxX - kostka.position.x) * 5 * deltaTime 
        kostka.position.y += (parallaxY - kostka.position.y) * 5 * deltaTime
      }

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()